/*
  IMPORTANT: this file cannot reference any modules that are related to react & redux
  this is because service-worker runs under a different scope and cannot use those modules
*/

import { getDatabase } from 'database';
import * as tokenHelper from 'helpers/token-helper';

export const JWT_BACKGROUND_TOKEN = 'Background';
export const JWT_SESSION_TOKEN = 'Session';
export const LAST_ACTION = 'LastAction';

export async function readToken(key: string): Promise<string> {
  const db = await getDatabase();
  const token = await db.read(db.config.indexes.Token, key) as string;
  return token;
}

export async function storeToken(key: string, token: string): Promise<void> {
  const db = await getDatabase();
  if (await readToken(key)) {
    await db.put(db.config.indexes.Token, token, key);
  } else {
    await db.add(db.config.indexes.Token, token, key);
  }
}

export async function removeSessionToken() {
  const db = await getDatabase();
  await db.remove(db.config.indexes.Token, JWT_SESSION_TOKEN);
}

export async function readLastActionTimestamp(): Promise<number> {
  const db = await getDatabase();
  const lastAction = await db.read(db.config.indexes.Token, LAST_ACTION) as number;
  return lastAction;
}

export async function storeLastAction(lastActionTimestamp: number): Promise<void> {
  const db = await getDatabase();
  if (await readLastActionTimestamp()) {
    await db.put(db.config.indexes.Token, lastActionTimestamp, LAST_ACTION);
  } else {
    await db.add(db.config.indexes.Token, lastActionTimestamp, LAST_ACTION);
  }
}

export async function getCurrentUser(): Promise<string> {
  const token = await readToken(JWT_SESSION_TOKEN);
  if (!token) {
    return '';
  }
  const jwt = tokenHelper.decodeToken(token);
  return jwt.sub;
}

export async function getUserPermissions(): Promise<string> {
  const token = await readToken(JWT_SESSION_TOKEN);
  if (!token) {
    return '';
  }
  const jwt = tokenHelper.decodeToken(token);
  return jwt.perm;
}


// WEBPACK FOOTER //
// ./src/services/token-service.ts